import React from 'react';
import { Box } from '@mui/material';
import { LogoIcon } from '../../../assets/icons';
import './styles.css';

export enum LogoLoaderSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}

export enum LogoLoaderAnimate {
  SPIN = 'spin',
  FADE = 'fade',
  PULSE = 'pulse',
  BOUNCE = 'bounce',
}

interface ILogoLoaderProps {
  size?: LogoLoaderSize;
  animate?: LogoLoaderAnimate;
  className?: string;
  inline?: boolean;
}

export const LogoLoader: React.FC<ILogoLoaderProps> = ({
  size,
  animate,
  className,
  inline,
}) => {
  const loaderSizes = {
    [LogoLoaderSize.XS]: 32,
    [LogoLoaderSize.S]: 64,
    [LogoLoaderSize.M]: 128,
    [LogoLoaderSize.L]: 256,
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={inline ? 'min-content' : '100%'}
      alignSelf="center"
      flexGrow={inline ? 0 : 1}
      fontSize={loaderSizes[size || LogoLoaderSize.S]}
      className={className}
    >
      <LogoIcon className={animate || LogoLoaderAnimate.FADE} />
    </Box>
  );
};
